export default "key,enValue,enValid,frValue,frValid\nbasemap.select,Select basemap,1,Sélectionner la carte de base,1\nbasemap.title,Basemap,1,Carte de base,1"